import React from 'react'
import styled from 'styled-components'
import { string, func } from 'prop-types'
import { rgba, stripUnit } from 'polished'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import { greyLight, black, borderColor } from 'styles/colors'
import { square } from 'styles/global'
import { H1, H4 } from 'styles/typography'

import Wrapper from 'components/Wrapper'
import Section from 'components/Section'
import Icon from 'components/Icon'

import LeftArrow from 'icons/left-arrow.svg'

const Container = styled.div`
  position: relative;
  text-align: center;
`

const Heading = styled(H1)`
  font-family: 'Trim Poster';
  letter-spacing: 0.02em;
  color: ${black};
  padding: 0 ${spacing.large};
  margin-bottom: ${stripUnit(spacing.small) * 1.5 + 'px'};

  ${media.medium`
    margin-bottom: ${spacing.medium};
  `};
`

const Description = styled.div`
  margin-bottom: ${spacing.medium};
  padding: 0 ${spacing.large};
  color: ${black};
  font-size: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  ${media.small`
    font-size: 11px;
  `};

  ${media.medium`
    margin-bottom: ${spacing.large};
    padding: 0;
    font-size: 12px;
  `};
`

const Inner = styled.div`
  max-width: 600px;
  margin: 0 auto;

  ${media.medium`
    max-width: 700px;
  `};

  ${media.large`
    max-width: 760px;
  `};

  ${media.xLarge`
    max-width: 840px;
  `};
`

const Price = styled(H4)`
  color: ${black};

  sub {
    bottom: 0;
    font-size: 65%;

    ${media.medium`
      font-size: 55%;
    `};
  }
`

const Compare = styled.sub`
  text-decoration: line-through;
  margin-right: ${spacing.small};
  color: ${greyLight};
`

const Back = styled.button`
  position: absolute;
  top: ${spacing.large};
  left: ${spacing.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${rgba(borderColor, 0.75)};
  ${square('32px')};

  ${media.small`
    ${square('40px')};
  `};

  ${media.medium`
    display: none;
  `};
`

const CollectionHeader = ({ heading, description, comparePrice, onBackClick, packPrice }) => {
  return (
    <Container>
      {onBackClick && (
        <Back onClick={onBackClick}>
          <Icon icon={<LeftArrow />} />
        </Back>
      )}
      <Section>
        <Wrapper>
          <Inner>
            <Heading as="h1">{heading}</Heading>
            {description && (
              <Description>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </Description>
            )}
            {packPrice && (
              <Price comparePrice={comparePrice}>
                {comparePrice && <Compare>{comparePrice}</Compare>}
                {packPrice}
                <sub>/pack</sub>
              </Price>
            )}
          </Inner>
        </Wrapper>
      </Section>
    </Container>
  )
}

CollectionHeader.propTypes = {
  heading: string,
  description: string,
  packPrice: string,
  comparePrice: string,
  onBackClick: func
}

export default CollectionHeader
